import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    transactions: []
};

export const scanProductSlice = createSlice({
    name: "scanProducts",
    initialState,
    reducers: {
        addTransaction: (state, action) => {
            state.transactions.push({
                id: action.payload.id,
                products: []
            });
        },
        setProductsForTransaction: (state, action) => {
    const { transactionId, products } = action.payload;

    // Check if the transaction already exists
    let transaction = state.transactions.find(t => t.id === transactionId);

    if (!transaction) {
        // If not, create it
        transaction = {
            id: transactionId,
            products: []
        };
        state.transactions.push(transaction);
    }

    // Replace products in this transaction
    transaction.products = products.map(p => ({
        id: p.id,
        quantity: p.quantity || 1
    }));
},
addProductToTransaction: (state, action) => {
    const { transactionId, productId } = action.payload;

    const transaction = state.transactions.find(t => t.id === transactionId);
    if (transaction) {
        const existingProduct = transaction.products.find(p => p.id === productId);
        if (existingProduct) {
            existingProduct.quantity += 1; // ← just increment by 1
        } else {
            transaction.products.push({ id: productId, quantity: 1 }); // ← add as new
        }
    }
},
     removeProductFromTransaction: (state, action) => {
            const { transactionId, productId } = action.payload;
            const transaction = state.transactions.find(t => t.id === transactionId);
            if (transaction) {
                transaction.products = transaction.products.filter(p => p.id !== productId);
            }
        },

        removeTransaction: (state, action) => {
            state.transactions = state.transactions.filter(t => t.id !== action.payload.id);
        },

        // ✅ Reset the state to initial
        resetProductTransaction: () => initialState
    }
});

export const {
    addTransaction,
    addProductToTransaction,
    removeProductFromTransaction,
    removeTransaction,
    resetProductTransaction,
    setProductsForTransaction
} = scanProductSlice.actions;

export default scanProductSlice.reducer;
